import { z } from "zod";
import { API_SERVICE_NAME } from "./constants";
import { apiSuccessSchema } from "./envelope";

/**
 * Полезная нагрузка `GET /api/v1/health`.
 * `checkedAt` — UTC ISO-8601 (И-11 / НФТ-19).
 */
export const healthStatusSchema = z.object({
  status: z.literal("ok"),
  service: z.literal(API_SERVICE_NAME),
  checkedAt: z.string().datetime({ offset: true }),
});

/** Тип статуса health-check. */
export type HealthStatus = z.infer<typeof healthStatusSchema>;

/** Конверт успешного health-check. */
export const healthResponseSchema = apiSuccessSchema(healthStatusSchema);

/** Тип ответа health-check. */
export type HealthResponse = z.infer<typeof healthResponseSchema>;
